import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Package, Mail, LogOut, KeyRound, ShieldCheck, Sparkles } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const items = [
    { to: "/admin/dashboard", label: "Dashboard", icon: LayoutDashboard },
    { to: "/admin/inventory", label: "Inventory", icon: Package },
    { to: "/admin/solitaires", label: "Solitaires", icon: Sparkles },
    { to: "/admin/enquiries", label: "Enquiries", icon: Mail },
    { to: "/admin/settings", label: "Settings", icon: KeyRound },
  ];

  const doLogout = async () => {
    await logout();
    nav("/admin");
  };

  return (
    <div className="min-h-screen flex">
      <aside className="w-64 bg-ink-800/80 border-r border-white/5 p-6 flex flex-col">
        <div className="flex items-center gap-3 pb-6 border-b border-white/5">
          <img src="https://customer-assets.emergentagent.com/job_gem-catalogue/artifacts/nrqp6drv_Untitled%20design-9.png" className="h-9 w-9" alt="logo" />
          <div>
            <div className="font-display text-sm text-ivory tracking-wider">BHOLAA JEWELS</div>
            <div className="overline text-rose-gold">Owner Panel</div>
          </div>
        </div>
        <nav className="flex-1 py-6 space-y-1">
          {items.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 border-l-2 text-sm tracking-wide transition-colors ${isActive ? "border-rose-gold text-rose-gold bg-rose-gold/5" : "border-transparent text-ivory/60 hover:text-ivory hover:bg-white/5"}`
              }
              data-testid={`sidebar-${it.label.toLowerCase()}`}
            >
              <it.icon className="w-4 h-4" /> {it.label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-white/5 pt-4 space-y-2">
          <div className="flex items-center gap-2 text-xs text-ivory/50">
            <ShieldCheck className="w-3 h-3 text-rose-gold" /> {user?.email}
          </div>
          <button onClick={doLogout} className="flex items-center gap-2 text-sm text-ivory/60 hover:text-hallmark" data-testid="admin-logout-button">
            <LogOut className="w-4 h-4" /> Logout
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
}
